import styled from 'styled-components';

import InputComponent from 'xpi-black-ui/Base/Input';

import { LoadingContainer } from 'xpi-black-ui/Base/Loading/styles';

export const Tag = styled.div`
  ${LoadingContainer} {
    position: absolute;
    height: 100%;
    background: rgba(49, 49, 49, 0.85);
  }
`;

export const Input = styled(InputComponent)`
  opacity: 0;
  z-index: 100;
  bottom: 24px;
  width: 137px;
  height: 32px;
  cursor: pointer;
  position: absolute;
`;
